import { render, staticRenderFns } from "./ProductManual.vue?vue&type=template&id=675936f1&scoped=true&"
import script from "./ProductManual.vue?vue&type=script&lang=js&"
export * from "./ProductManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675936f1",
  null
  
)

export default component.exports